import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "text-muted small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_ExportButtons = _resolveComponent("ExportButtons")!
  const _component_Card = _resolveComponent("Card")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ExportButtons, {
          csv: _ctx.exportGridsToExcel,
          pdf: _ctx.exportGridsToPdf,
          xlsx: _ctx.exportGridsToExcel
        }, null, 8, ["csv", "pdf", "xlsx"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Card, {
              badges: 1,
              "info-badge-description": [_ctx.cardStore[0]],
              "info-badge-title": [_ctx.$t('components.reports.geofencing.totalEvents')],
              status: _ctx.$t('components.reports.geofencing.geofencingReport'),
              icon: "bi bi-geo-alt"
            }, null, 8, ["info-badge-description", "info-badge-title", "status"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DxDataGrid, {
            ref: _ctx.dataGridRef,
            "allow-column-reordering": true,
            "allow-column-resizing": true,
            "column-auto-width": true,
            "column-hiding-enabled": true,
            "data-source": _ctx.store,
            "hover-state-enabled": true,
            "remote-operations": true,
            "row-alternation-enabled": true,
            "show-borders": true,
            "show-column-lines": true,
            "show-row-lines": false
          }, {
            vehicleTemplate: _withCtx(({ data }) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.vehicle?.registration || 'N/A'), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.imei), 1)
              ])
            ]),
            eventTypeTemplate: _withCtx(({ data }) => [
              _createElementVNode("span", {
                class: _normalizeClass({
              'badge badge-success fw-bolder fs-8 py-1': data.data.event_type === 'in',
              'badge badge-primary fw-bolder fs-8 py-1': data.data.event_type === 'out'
            })
              }, _toDisplayString(data.data.event_type === 'in' ? _ctx.$t('components.reports.geofencing.zoneEntry') : _ctx.$t('components.reports.geofencing.zoneExit')), 3)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DxHeaderFilter, { visible: false }),
              _createVNode(_component_DxPaging, { "page-size": 10 }),
              _createVNode(_component_DxPager, {
                "allowed-page-sizes": [10, 15, 20, 50],
                "show-info": true,
                "show-navigation-buttons": true,
                "show-page-size-selector": true
              }),
              _createVNode(_component_DxFilterRow, { visible: true }),
              _createVNode(_component_DxColumnFixing, { enabled: true }),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.reports.geofencing.registrationNumber'),
                "data-field": "vehicle_info",
                "cell-template": "vehicleTemplate",
                "allow-filtering": false,
                "allow-sorting": false,
                "calculate-cell-value": () => _ctx.vehicle?.registration || 'N/A'
              }, null, 8, ["caption", "calculate-cell-value"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.reports.geofencing.eventType'),
                "data-field": "event_type",
                "cell-template": "eventTypeTemplate",
                "allow-filtering": false,
                "allow-sorting": false,
                "calculate-cell-value": (rowData) => rowData.event_type === 'in' ? this.$t('components.reports.geofencing.zoneEntry') : this.$t('components.reports.geofencing.zoneExit')
              }, null, 8, ["caption", "calculate-cell-value"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.reports.geofencing.eventDate'),
                "data-field": "event_date",
                "allow-filtering": false,
                "allow-sorting": true
              }, null, 8, ["caption"]),
              _createVNode(_component_DxColumn, {
                caption: _ctx.$t('components.reports.geofencing.zoneName'),
                "data-field": "zone_name",
                "allow-filtering": true,
                "allow-sorting": false
              }, null, 8, ["caption"])
            ]),
            _: 1
          }, 8, ["data-source"])
        ])
      ]))
}